import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types'
import AsyncSelect from 'react-select/async';
import { handleRequestError, Request } from '../../helpers/request'
import debounce from 'lodash/debounce'
import { useIntl } from 'react-intl'

// TODO required attribute hack https://github.com/JedWatson/react-select/issues/3140

function LocalisationSelect({
                                value,
                                onChange,
                                id,
                                placeholder,
                                injectOptionAll
                            }) {
    const intl = useIntl()
    const [localisation, setLocalisation] = useState(null)

    const optionAll = {
        value: 'all',
        label: intl.formatMessage({ id: "forms.localisation.options.all" }),
    }

    function apiRowToSelectOption(option) {
        if (!option?.display_name) {
            return null
        }
        option.value = option.display_name
        option.label = `${option.display_name} (${option.departement})`
        return option
    }

    useEffect(() => {
        if (!localisation && value) {
            if (value === optionAll.value) {
                setLocalisation(optionAll)
            } else {
                Request.get(`cities?name=${value}`).then(({ data }) => {
                    setLocalisation(apiRowToSelectOption(data?.[0]))
                })
            }
        } else if (localisation && !value) {
            setLocalisation(null)
        }
    }, [localisation, value])

    const loadOptions = (inputValue, callback) => {
        Request.get(`cities?name=${inputValue}`)
            .then(({ data }) => {
                data.forEach(apiRowToSelectOption)
                if (injectOptionAll) {
                    data.unshift(optionAll)
                }
                callback(data)
            })
            .catch(handleRequestError)
    };
    const loadOptionsDebounced = debounce((inputValue, callback) => loadOptions(inputValue, callback), 250)

    const handleChange = option => {
        setLocalisation(option)
        onChange(option.value)
    }

    return (
        <AsyncSelect
            inputId={id}
            className='react-select-container'
            classNamePrefix='react-select'
            getOptionLabel={option => option.label}
            getOptionValue={option => option.value}
            loadOptions={loadOptionsDebounced}
            loadingMessage={() => intl.formatMessage({ id: "forms.select.loading" })}
            noOptionsMessage={() => intl.formatMessage({ id: "forms.select.no-options" })}
            value={localisation}
            defaultOptions={true}
            openMenuOnFocus={true}
            placeholder={placeholder ?? intl.formatMessage({ id: "forms.localisation.placeholder" })}
            onChange={handleChange}
        />
    )
}

LocalisationSelect.defaultProps = {
    onChange: () => {
    },
    injectOptionAll: false,
}

LocalisationSelect.propTypes = {
    value: PropTypes.string,
    onChange: PropTypes.func,
    id: PropTypes.string,
    placeholder: PropTypes.string,
    injectOptionAll: PropTypes.bool,
}

export default LocalisationSelect;
